import { useCallback } from 'react';

import tokenManager from 'client/utils/tokenManager';

export default function useLogout() {
    return useCallback(async callback => {
        const result = await tokenManager.logout();

        if (result) {
            if (typeof callback === 'function') {
                await callback();
            }
            window.location.reload();
        }
    }, []);
}
